import React, {useEffect, useState} from 'react';
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";

export default function SelectFilter({ links, id, onFilterSelect, extraClasses, reset }) {

    const [title, setTitle] = useState(links[0].name);

    const onFilterChange = (selection) => {
        onFilterSelect(selection.key, selection.ascend);
        setTitle(selection.name);
    }

    useEffect(() => {
        setTitle(links[0].name);
    }, [reset]);

    const renderLinks = () => {
        return (
            links.map( (link, i) => {
                return (
                    <Dropdown.Item key={`${id}_${i}`} className={'border-bottom'} onClick={() => onFilterChange(link)}>
                        {link.name}
                    </Dropdown.Item>
                )
            })
        )
    }

    return (
        <>
            <DropdownButton
                id={id}
                variant={'select'} // applies btn-select: displayed btn as input select
                title={title}
                className={`${extraClasses}`}>
                {renderLinks()}
            </DropdownButton>
        </>
    )
}